import { useEffect } from 'react';

import { IS_IPAD } from 'state_management/constants';

export default function IPadZoomController() {
  useEffect(() => {
    if (!IS_IPAD) return;
    // On initial render, reset the attributes and iPad OS seems to disable auto and pinch zoom of whole page properly
    const viewportmeta = document.querySelector('meta[name="viewport"]');
    viewportmeta?.setAttribute('content', 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0');
  }, []);

  return null;
}
